import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

export const Route = createFileRoute("/admin/_panel/_core/")({
  component: Component,
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Dashboard", { ns: "core.shared" }),
      hideCrumb: true,
    }) satisfies ChildRouteContext,
});

function Component() {
  return (
    <div className="relative flex h-full flex-1 flex-col">
      <div className="relative z-20 grid grid-cols-4 gap-6 px-8 py-12"></div>
    </div>
  );
}
